import React, { lazy } from 'react';
import { StarIcon, CheckCircleIcon } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
const testimonials = [{
  type: 'whatsapp',
  name: 'Carolina M.',
  time: '10:42',
  message: 'Mi Beagle no paraba de ladrar cuando me iba a trabajar. Los vecinos se quejaban. En solo una semana con el protocolo, ahora se queda durmiendo. Es un milagro. 😭❤️',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&fm=webp&q=75',
  dogImg: ''
}, {
  type: 'text',
  name: 'Roberto V.',
  location: 'Vitacura, Chile',
  quote: 'Pensé que mi perro necesitaba correr 2 horas al día. Resulta que 10 minutos de estos ejercicios mentales lo dejan mucho más relajado. Increíble método.'
}, {
  type: 'instagram',
  name: '@vale_y_luna',
  message: 'La ansiedad por separación de mi perrita era extrema. Rompía todo. El cambio ha sido brutal, ahora es una perra tranquila y feliz en el departamento. ✨🐾',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=56&h=56&fit=crop&fm=webp&q=75'
}, {
  type: 'text',
  name: 'Andrés G.',
  location: 'Las Condes, Chile',
  quote: 'Por fin puedo invitar gente a mi casa sin que mi perro se vuelva loco saltando y ladrando. El protocolo de visitas es oro puro.'
}, {
  type: 'whatsapp',
  name: 'María José',
  time: '18:15',
  message: '¡Funciona! Hoy pude tomarme un café tranquila mientras él jugaba con su caja de olfato. Antes me exigía atención 24/7. Mil gracias.',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&fm=webp&q=75'
}, {
  type: 'text',
  name: 'Diego P.',
  location: 'Providencia, Chile',
  quote: 'Lo mejor es que no usa castigos. Todo es en positivo y usando sus instintos. Mi perro ahora me hace caso a la primera.'
}];
export function TestimonialsSection() {
  return <section className="py-24 px-5 max-w-6xl mx-auto bg-zen-beige/30 rounded-[3rem] my-12 pt-[10px] pb-[10px] mt-[28px] mb-[28px]" data-id="element-260">
      <FadeInUp className="pt-[20px] pb-[20px] mt-[10px] mb-[10px]" data-id="element-261">
        <div className="text-center mb-16" data-id="element-262">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-slate-dark mb-6" data-id="element-263">
            Historias de Éxito
          </h2>
          <div className="flex items-center justify-center gap-2" data-id="element-264">
            <div className="flex text-yellow-400" data-id="element-265">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 fill-current" data-id="element-266" />)}
            </div>
            <span className="font-bold text-slate-dark flex items-center gap-1" data-id="element-267">
              Trustpilot Verificado
            </span>
          </div>
        </div>
      </FadeInUp>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-268">
        {testimonials.map((t, index) => <FadeInUp key={index} delay={index * 0.1} data-id="element-269">
            {t.type === 'whatsapp' ? <div className="bg-[#EFEAE2] p-4 rounded-3xl h-full flex flex-col shadow-sm border border-black/5" data-id="element-270">
                <div className="bg-[#075E54] text-white p-3 rounded-t-2xl flex items-center gap-3 -mt-4 -mx-4 mb-4" data-id="element-271">
                  <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover" width={40} height={40} loading="lazy" decoding="async" data-id="element-272" />
                  <div data-id="element-273">
                    <p className="font-bold text-sm" data-id="element-274">{t.name}</p>
                    <p className="text-[10px] opacity-80" data-id="element-275">en línea</p>
                  </div>
                </div>
                <div className="bg-[#DCF8C6] p-3 rounded-2xl rounded-tl-none shadow-sm relative mb-2 self-start max-w-[90%]" data-id="element-276">
                  {t.dogImg}
                  <p className="text-slate-dark text-sm leading-relaxed" data-id="element-277">
                    {t.message}
                  </p>
                  <span className="text-[10px] text-slate-dark/50 absolute bottom-1 right-2" data-id="element-278">
                    {t.time}
                  </span>
                </div>
              </div> : t.type === 'instagram' ? <div className="bg-white p-6 rounded-3xl h-full flex flex-col shadow-sm border border-black/5" data-id="element-279">
                <div className="flex items-center gap-3 mb-4 pb-4 border-b border-gray-100" data-id="element-280">
                  <div className="w-10 h-10 rounded-full p-[2px] bg-gradient-to-tr from-yellow-400 to-fuchsia-600" data-id="element-281">
                    <img src={t.avatar} alt={t.name} className="w-full h-full rounded-full object-cover border-2 border-white" width={56} height={56} loading="lazy" decoding="async" data-id="element-282" />
                  </div>
                  <p className="font-bold text-sm text-slate-dark" data-id="element-283">{t.name}</p>
                </div>
                <div className="bg-gray-100 p-4 rounded-2xl rounded-tl-none text-sm text-slate-dark leading-relaxed" data-id="element-284">
                  {t.message}
                </div>
              </div> : <div className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow h-full flex flex-col border border-black/5" data-id="element-285">
                <div className="flex text-yellow-400 mb-4" data-id="element-286">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-287" />)}
                </div>
                <p className="text-slate-dark/80 italic mb-6 flex-grow text-base leading-relaxed" data-id="element-288">
                  "{t.quote}"
                </p>
                <div className="mt-auto pt-4 border-t border-zen-beige" data-id="element-289">
                  <p className="font-bold text-slate-dark text-sm" data-id="element-290">{t.name}</p>
                  <p className="text-xs text-slate-dark/60 mb-2" data-id="element-291">
                    {t.location}
                  </p>
                  <div className="flex items-center gap-1 text-[10px] font-medium text-slate-dark bg-pistachio/20 inline-flex px-2 py-0.5 rounded-full" data-id="element-292">
                    <CheckCircleIcon className="w-3 h-3 text-green-600" data-id="element-293" />
                    Cliente Verificado
                  </div>
                </div>
              </div>}
          </FadeInUp>)}
      </div>
    </section>;
}